/**
 * Action Types
 */
export const ACTIONS = {
    LOADING: 'AUTH_LOADING',
    RETRIEVED_USER: 'AUTH_RETRIEVED_USER',
};

/**
 * Action Creators
 */
export const actionCreators = {
    _loading(isLoading)
    {
        return { type: ACTIONS.LOADING, payload: isLoading };
    },

    _retrievedUser(user)
    {
        return { type: ACTIONS.RETRIEVED_USER, payload: user };
    },
};

/**
 * Action Dispatchers
 */
export function loading(isLoading)
{
    return (dispatch) =>
    {
        dispatch(actionCreators._loading(isLoading));
    };
}

export function retrievedUser(user)
{
    return (dispatch) =>
    {
        dispatch(actionCreators._retrievedUser(user));
    };
}
